// Copyright ©️ 2026 eVolve MEP, LLC

import { AppShell } from '@mantine/core';
import { Navigate, Outlet } from 'react-router';

import { EULAModal } from 'app/EULAModal';
import { AppMain } from 'app/Layout/AppMain';
import { moduleRoute } from 'app/Layout/NavBar/globalNavigationMenu';
import { useIsMobile } from 'hooks/useIsMobile';
import { FabricationBendCreatorProvider } from 'modules/Shop/EvolveFabrication/BendCreator/useFabricationBendCreator';

import { MobileHeaderBar } from './MobileHeaderBar';
import { DesktopNavBar } from './NavBar/DesktopNavBar';
import { NavBarContent } from './NavBar/NavBarContent/NavBarContent';

export const Layout = () => {
  const isMobile = useIsMobile();

  if (window.location.pathname === '/' || window.location.pathname === `/${moduleRoute}`) {
    return <Navigate to={`/${moduleRoute}/`} replace />;
  }

  return (
    <FabricationBendCreatorProvider>
      {isMobile ? (
        <>
          <MobileHeaderBar />
          <AppShell.Aside bg="app-shell-gray.9" withBorder={false}>
            <NavBarContent />
          </AppShell.Aside>
        </>
      ) : (
        <DesktopNavBar />
      )}
      <AppMain>
        <Outlet />
      </AppMain>
      <EULAModal />
    </FabricationBendCreatorProvider>
  );
};
